import React from 'react';
import './AboutUs.scss';

const AboutUsSection = props => {
  return (
    <div className="row about-us">
      <div className="col-md-8 col-md-offset-2 text-center">
        <h2 className="section-header">Wichtige Information für unsere Unterstützer*innen</h2>
        <p>
	    Die Ev. Gemeinde Köln hat entschieden, die Lutherkirche im Jahr 2027 endgültig zu schliessen.
        </p>
	<p><strong>Aber wir machen weiter!</strong></p>
        <p>Im Dezember 2026 wird die Aktion wie gewohnt in der Lutherkirche stattfinden.<br /> Für die Zeit danach suchen wir einen neuen Ort in der Südstadt. Über den aktuellen Stand informiere ich Sie/euch, liebe Christkind-Helfer und -Helferinnen, auf der Website meines Vereins "Hans sucht das Glück e.V." <a href="https://www.hans-sucht-das-glueck.de/de/unsere-arbeit/aktuelles" target="_blank">https://www.hans-sucht-das-glueck.de/de/unsere-arbeit/aktuelles</a>.
        </p>
        <p>Pfarrer Hans Mörtter (i.R.)</p>
      </div>
    </div>
  );
};
export default AboutUsSection;



// WEBPACK FOOTER //
// ./src/Containers/HomeElements/AboutUs.js